export default "__VITE_ASSET__3d684c8d__"